/* eslint-disable no-debugger */
var angular = require('angular');
var _module = require('../../components/module');
var babou = require('babou-js');
var config = require('config');
var _ = require('lodash');
var simpleCypher = require('../../../libs/simple-cypher');

//Babou JS Setup
babou.setConfig({
    url: config.babou.url,
    api_key: config.babou.apiKey
});

_module.service('$babou', [
    '$log',
    '$q', 
    function Babou($log,$q){
        var _searchListings = babou.searchListings;
        babou.searchListings = function(areas,options){

            return $q.when(_searchListings.apply(babou,[areas,options]));
        };

        var _searchRealtors = babou.getPreferredAgent;
        babou.getPreferredAgent = function(agentData, options){
            return $q.when(_searchRealtors.apply(babou, [agentData, options]));
        };

        babou.formatListingFields = function(listing,filtered){
            if(listing.LRScores){
                var newListing = {
                    active: listing.Active,
                    address: listing.FormattedAddress,
                    baths: listing.Bathrooms,
                    beds: listing.Bedrooms,
                    description: listing.Description,
                    floors: listing.NumFloors,
                    hero: listing.HeroImage,
                    home_size: listing.LivingArea,
                    id: simpleCypher.encode(listing.LRSource, listing.id),
                    lat: listing.Latitude,
                    lon: listing.Longitude,
                    listing_category: listing.ListingCategory,
                    listing_date: listing.ListingDate,
                    listing_source: listing.LRSource,
                    lot_size: listing.LotSize,
                    num_photos: listing.NumPhotos,
                    open_houses: listing.OpenHouseDate,
                    price: listing.ListPrice,
                    realtor_company: listing.RealtorCompany,
                    realtor_name: listing.RealtorName,
                    sub_type: listing.PropertySubType,
                    reports: {
                        area: {score: listing.LRScores.area},
                        outdoors: {score: listing.LRScores.outdoors},
                        schools: {score: listing.LRScores.schools},
                        restaurant: {score: listing.LRScores.restaurant}
                    },
                    type: listing.PropertyType,
                    year: listing.YearBuilt
                };
                if(!angular.isUndefined(listing.MatchScore)) {
                    newListing.match_score = listing.MatchScore;
                }
                filtered.push(newListing);
            }
        };
        
        return babou;
    }
]);